@if (enabled()) {
<div class="student-banner">
  <div class="student-banner__content" [class.student-banner__content--pre-pic-day]="isPrePicDay()">
    <span class="student-banner__label"> {{ 'MY_DASHBOARD_SHOPPING_FOR' | ltTranslate }}: </span>

    <div class="student-banner__student">
      @if (isPrePicDay()) {
      <div class="student-banner__item">
        <lt-icon name="fa-regular-calendar" class="student-banner__icon" />
        <span class="student-banner__text student-banner__text--bold" [title]="eventNameAndYear()"
          >{{ eventNameAndYear() }}</span
        >
      </div>

      <div class="student-banner__item">
        <lt-icon name="fa-regular-graduation-cap" class="student-banner__icon student-banner__icon--graduation-cap" />
        <span class="student-banner__text student-banner__text--school should-stay-masked" [title]="schoolName()"
          >{{ schoolName() }}</span
        >
      </div>
      } @else { @if (previewLook()) {
      <div class="student-banner__avatar" aria-hidden="true">
        <lt-avatar [lookImage]="previewLook()!" testId="student-banner-image" />
      </div>
      }

      <span class="student-banner__name should-stay-masked" [title]="displayName()"> {{ displayName() }} </span>
      }
    </div>
  </div>
</div>
}
